const type = {
  base: 'PoynterOSDisp-Semibold',
  bold: 'Roboto-Bold',
  emphasis: 'Roboto-Light',
  regular: 'Roboto-Regular',
}

export default type
